/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import './assets/styles/global.css';

import moment from 'moment';
import { Box, Modal } from '@mui/material';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { LoadingProvider } from './providers/use-loading';
import { SelectedStateCityProvider } from './providers/use-selected-state-city';
import { UserSignInProvider } from './providers/use-signin';
import { UserSingUpProvider } from './providers/use-signup';
import { UserShopProvider } from './providers/use-shop';
import { UserUpdateProvider } from './providers/use-user-update';
import { store } from './store';

import 'moment/locale/pt-br'; // without this line it didn't work

import Routes from './routes';
import { getStorege, saveStorege } from './helpers/db_storage';
import { coordinates } from './helpers/utils/locationCoordinates';

import SelectStateAndCity from './components/SelectStateAndCity';

const styleModal = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  p: 4,
  outline: 'none',
};

const App: React.FC = () => {
  moment.locale('pt-br');
  const [openModalSelectStateCity, setOpenModalSelectStateCity] =
    useState(false);

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const { lat, lng } = await coordinates();

      const dataLocation = getStorege('@mais/delivery/dataStateCity');

      if (dataLocation != null && typeof dataLocation === 'object') {
        dataLocation.lat = lat;
        dataLocation.lng = lng;
        saveStorege('@mais/delivery/dataStateCity', dataLocation);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    (async () => {
      const dataStorage = JSON.parse(
        localStorage.getItem('@mais/delivery/dataStateCity') as string,
      );
      const dataStorageAccess = localStorage.getItem(
        '@mais/delivery/access_shop',
      );
      if (!dataStorageAccess) {
        setOpenModalSelectStateCity(
          !(
            dataStorage?.dsCidade &&
            dataStorage?.idCidade &&
            dataStorage?.idMarketplace
          ),
        );
      }
    })();
  }, []);

  return (
    <div
      style={{
        margin: 0,
        padding: 0,
        display: 'flex',
        backgroundColor: '#ffffff',
        width: '100%',
        maxWidth: 680,
      }}
    >
      <ToastContainer />
      <LoadingProvider>
        <GoogleOAuthProvider
          clientId={process.env.REACT_APP_CLIENT_ID_GOOGLE || ''}
        >
          <UserSignInProvider>
            <UserSingUpProvider>
              <SelectedStateCityProvider>
                <Modal
                  open={openModalSelectStateCity}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={styleModal}>
                    <SelectStateAndCity />
                  </Box>
                </Modal>
                <UserShopProvider>
                  <UserUpdateProvider>
                    <Provider store={store}>
                      <Routes />
                    </Provider>
                  </UserUpdateProvider>
                </UserShopProvider>
              </SelectedStateCityProvider>
            </UserSingUpProvider>
          </UserSignInProvider>
        </GoogleOAuthProvider>
      </LoadingProvider>
    </div>
  );
};

export default App;
